/**
 * ยอดที่ต้องจ่าย "ตอนนี้" ของแต่ละวิธีชำระ (เต็มจำนวน / มัดจำ / ชำระวันเข้าพัก)
 *
 * ใช้แสดงในการ์ดเลือกวิธีชำระ ให้ลูกค้าเห็นยอดของทุกตัวเลือกพร้อมกันก่อนเลือก
 * สูตรเหมือนกับ payAmount ที่ส่งไปตอนจองทุกประการ (BookingCart / BookingModal /
 * BookingRoomFlexibleModal) -- ถ้าแก้สูตรที่นั่นต้องแก้ที่นี่ด้วย ไม่งั้นการ์ดจะโชว์ยอดไม่ตรงกับที่เก็บจริง
 *
 * เงินประกันห้องพัก (security deposit) แยกออกมาต่างหาก เพราะเป็นเงินที่คืนหลังเช็คเอาท์
 * และเป็นตัวที่ลูกค้าสับสนกับ "มัดจำ" มากที่สุด
 */
export function paymentBreakdown({
  type,
  roomTotal = 0, // ค่าห้องก่อนหักส่วนลด
  discount = 0,
  sumAddons = 0, // บริการเสริม + ผู้เข้าพักเพิ่ม + สัตว์เลี้ยง
  depositPrice = 0, // มัดจำค่าห้อง (คิดส่วนลดตามเงื่อนไขที่พักแล้ว)
  depositAddonEnabled = false,
  depositType = 'percent',
  depositValue = 0,
  allowDiscountPartial = false,
  securityPrice = 0,
  securityOnCheckin = false,
}) {
  const n = (v) => Number(v || 0);
  const addonForPay = (type !== 'deposit' || !depositAddonEnabled)
    ? n(sumAddons)
    : (depositType === 'static' ? 0 : n(sumAddons) * (n(depositValue) / 100));

  let roomPart = 0;
  let addonPart = 0;
  if (type === 'full') {
    roomPart = n(roomTotal) - n(discount);
    addonPart = n(sumAddons);
  } else if (type === 'payonstay') {
    addonPart = n(sumAddons);
  } else if (type === 'deposit') {
    roomPart = n(depositPrice);
    addonPart = addonForPay;
  }

  const securityNow = securityOnCheckin ? 0 : n(securityPrice);
  const securityLater = securityOnCheckin ? n(securityPrice) : 0;
  // ส่วนลดใช้ได้เฉพาะจ่ายเต็ม เว้นแต่ที่พักอนุญาตให้ใช้กับการจ่ายบางส่วน
  const stayTotal = n(roomTotal) - ((type === 'full' || allowDiscountPartial) ? n(discount) : 0) + n(sumAddons);
  const payNow = roomPart + addonPart + securityNow;
  const remaining = Math.max(0, stayTotal - (roomPart + addonPart));

  return { type, roomPart, addonPart, securityNow, securityLater, stayTotal, payNow, remaining };
}

/** รวมหลายห้อง (ตะกร้า) */
export function sumBreakdowns(list) {
  const keys = ['roomPart', 'addonPart', 'securityNow', 'securityLater', 'stayTotal', 'payNow', 'remaining'];
  return (list || []).reduce((acc, b) => {
    keys.forEach((k) => { acc[k] = (acc[k] || 0) + Number(b[k] || 0); });
    acc.type = b.type;
    return acc;
  }, {});
}
